<div
  class="mx-auto min-h-screen relative"
  [style.padding-bottom.px]="footerStickyModalHeight$ | async"
>
  <div class="min-h-screen">
    <router-outlet></router-outlet>
  </div>
  @if (layout$ | async; as layout) {
    <div class="w-full shadow-inner text-center text-xs p-8 font-base text-neutral-500">
      @if (layout.powered_by) {
        <a
          [href]="layout.powered_by.url"
          target="_blank"
          >{{ layout.powered_by.text }}</a
        >
      }
    </div>
  }
  <app-notification-block></app-notification-block>
  <app-modals-container></app-modals-container>
</div>
